import OnboardingProgressCardRoot from './OnboardingProgressCard'
import useViewModel from './useViewModel'

export default function OnboardingProgressCard() {
  const viewModel = useViewModel()
  return <OnboardingProgressCardRoot {...viewModel} />
}
